<template>
   <header>
      <nav class="navbar fixed-top">
         <a  @click="$router.go(-1)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="0.3">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </a>
         <router-link to="" class="navbar-brand">{{activeTitle}}</router-link>
      </nav>
   </header>
</template>
<script>
export default {
  computed: {
    activeTitle(){
      return this.$store.getters.activeTitle;
    }
  }
}
</script>
<style >
.form-group .btn-outline {
    border: 1px solid #dfdfdf;
    border-radius: 25px;
    padding: 8px 15px;
    font-size: 12px;
    margin-right: 10px;
    color: #212121;
    font-weight: 500;
     margin: 10px;
}
.btn-outline:hover, .btn-outline.active{
  background-color: #F8E2D0;
    opacity: 1;
    color: #F58634!important;
    border-color:#F58634;
   
}
</style>